import { Container, Image } from 'react-bootstrap';
import BreatheEV_Logo from '../../Images/logo.png';
import PublicSoftwareVersionTable from './PublicSoftwareVersionTable';
import PublicChargerFirmwareTable from './PublicChargerFirmwareTable';
import styles from './ComplianceVersionDisclosure.module.css';

const ComplianceVersionDisclosure = () => {
    return (
        <div className={styles.page}>
            <Container>
                <div className={styles.hero}>
                    <Image src={BreatheEV_Logo} className={styles.logo} alt="BreatheEV" />
                    <div className={styles.heroText}>
                        <h2 className={styles.title}>Version Disclosure</h2>
                        <p className={styles.subtitle}>
                            Current and historical software and firmware versions.
                        </p>
                    </div>
                </div>
                <div className={styles.card}>
                    <PublicSoftwareVersionTable softwareType="webApp" title="Web App Versions" />
                </div>
                <div className={styles.card}>
                    <PublicSoftwareVersionTable softwareType="mobileApp" title="Native App (Mobile) Versions" />
                </div>
                {/* <PublicSoftwareVersionTable softwareType="breatheBE" title="Breathe BE Versions" /> */}
                <div className={styles.card}>
                    <PublicSoftwareVersionTable softwareType="csms" title="CSMS Versions" />
                </div>
                {/* <div className={styles.card}>
                    <PublicChargerFirmwareTable />
                </div> */}
            </Container>
        </div>
    );
};

export default ComplianceVersionDisclosure;
